import { render, staticRenderFns } from "./FormImage.vue?vue&type=template&id=2ab1412c&"
import script from "./FormImage.vue?vue&type=script&lang=js&"
export * from "./FormImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports